module.exports = __webpack_public_path__ + "static/media/instagram-full.0de08386.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/instagram-full.svg
// module id = 778
// module chunks = 0